import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/home/Home.vue'
import HomeView from '../views/home/overview/index.vue'

const isAuthenticated = () => {
  // 这里可以根据实际情况从 Vuex、Cookies、LocalStorage 等方式来检查用户登录状态
  return !!localStorage.getItem('token');
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: true },//需要登录才能进入
    children: [
      {
        path: '/home',
        name: 'HomeView',
        component: HomeView
      },
      //首页配置
      {
        path: '/homeconfig/banner',
        name: 'banner',
        component: () => import('@/views/home/homeconfig/banner')
      },
      {
        path: '/homeconfig/jingangDistrict',
        name: 'jingangDistrict',
        component: () => import('@/views/home/homeconfig/jingangDistrict')
      },
      //商品库
      {
        path: '/productmodule/classificationLibrary',
        name: 'classificationLibrary',
        component: () => import('@/views/home/productmodule/classificationLibrary')
      },
      {
        path: '/productmodule/productLibrary',
        name: 'productLibrary',
        component: () => import('@/views/home/productmodule/productLibrary')
      },
      //审核中心（历史/可选，非主流程）
      {
        path: '/auditing/audiList',
        name: 'audiList',
        component: () => import('@/views/home/auditing/audiList')
      },
      //订单管理
      {
        path: '/order/orderList',
        name: 'orderList',
        component: () => import('@/views/home/order/orderList')
      },
      //交易保障
      {
        path: '/guarantee/complaints',
        name: 'complaints',
        component: () => import('@/views/home/guarantee/complaints')
      },
      //用户管理
      {
        path: '/userlist/userManagement',
        name: 'userManagement',
        component: () => import('@/views/home/userlist/userManagement')
      },
      {
        path: '/userlist/userDetails',
        redirect: '/userlist/userManagement'
      },
      {
        path: '/userlist/userChannels',
        redirect: '/userlist/userManagement'
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/Login.vue')
  }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    // 如果访问的是登录页
    if (isAuthenticated()) {
      // 如果已经登录，重定向到首页或其他需要授权的页面
      next({ name: 'home' });
    } else {
      // 如果未登录，允许继续访问登录页
      next();
    }
  } else {
    // 对于其他需要授权的页面
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!isAuthenticated()) {
        // 如果未登录，重定向到登录页
        next({ name: 'login' });
      } else {
        // 如果已登录，允许继续访问
        next();
      }
    } else {
      // 对于不需要授权的页面，直接允许访问
      next();
    }
  }
});

export default router
